"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));

var _styles = require("./styles");

var Loading = function Loading(_ref) {
  var rows = _ref.rows;
  return /*#__PURE__*/_react.default.createElement(_styles.LoadingWrapper, null, (0, _toConsumableArray2.default)(Array(rows).keys()).map(function (row) {
    return /*#__PURE__*/_react.default.createElement(_styles.LoadingRow, {
      key: row
    }, /*#__PURE__*/_react.default.createElement(_reactLoadingSkeleton.default, {
      width: '100%'
    }));
  }));
};

var _default = Loading;
exports.default = _default;